import { registerSW } from 'virtual:pwa-register';

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      // Check for updates every 60 minutes
      setInterval(
        () => {
          registration.update();
        },
        60 * 60 * 1000
      );
    },
    onOfflineReady() {
      console.log('[PWA] App ready for offline use');
    },
    onNeedRefresh() {
      // New version available; reload to avoid version skew (chunk 404s)
      window.location.reload();
    },
  });
}
